const patternMakerData = {
  "sk8-hi": {
    display_name: "Sk8-Hi",
    image: "//images.vans.com/is/image/VansBrand/customs-sk8hi-classic?$scale-original$",
    svg_view: "two-shoes",
    default_recipe: "000620d0a9208d6cdf29a12c5fd5ec87",
    ugcDefaultSize: "9.0 Men = 10.5 Women",
    primaryUgcComponent: "quarters",
    product_type: "footwear"
  },
  "authentic-classic": {
    display_name: "Authentic",
    image: "//images.vans.com/is/image/VansBrand/customs-authentic-classic?$scale-original$",
    svg_view: "two-shoes",
    default_recipe: "5d0d3ef661870a5a4e697f6b85a83285",
    ugcDefaultSize: "9.0 Men = 10.5 Women",
    primaryUgcComponent: "vamp",
    secondaryUgcComponent: "quarters",
    product_type: "footwear"
  },
  "slip-on-classic": {
    display_name: "Slip On",
    image: "//images.vans.com/is/image/VansBrand/customs-slipon-classic?$scale-original$",
    svg_view: "two-shoes",
    default_recipe: "bbeee49cf5e274086a179cf86622cee2",
    ugcDefaultSize: "9.0 Men = 10.5 Women",
    primaryUgcComponent: "vamp",
    product_type: "footwear"
  },
  "era-classic": {
    display_name: "Era",
    image: "//images.vans.com/is/image/VansBrand/customs-era-classic?$scale-original$",
    svg_view: "two-shoes",
    default_recipe: "63fa927383bf11586ca528a202d3efee",
    ugcDefaultSize: "9.0 Men = 10.5 Women",
    primaryUgcComponent: "vamp",
    product_type: "footwear"
  },
  "old-skool-classic": {
    display_name: "Old Skool",
    image: "https://images.vans.com/is/image/VansBrand/customs-oldskool-classic?$scale-original$",
    svg_view: "two-shoes",
    default_recipe: "eff610acffc76fdeeda6c759d57135a4",
    ugcDefaultSize: "9.0 Men = 10.5 Women",
    primaryUgcComponent: "quarters",
    product_type: "footwear"
  },
  "backpack": {
    display_name: "Backpacks",
    image: "//images.vans.com/is/image/VansBrand/customs-base-img-backpack?$scale-original$",
    svg_view: "front-ugc",
    default_recipe: "e7837e8d14459251e8e695317d8c531f",
    ugcDefaultSize: "0.0",
    primaryUgcComponent: "front",
    product_type: "backpack"
  }
};

const ugcEntryPointData = {
  "sk8-hi": {
    display_name: "Sk8-Hi",
    image: "//images.vans.com/is/image/VansBrand/customs-sk8hi-classic?$scale-original$",
    svg_view: "two-shoes",
    ugc_component_name: "quarters",
    ugcImageRatio() {
      return 806 / 1015; // (height / width) of ugc placement image
    },
    product_type: "footwear"
  },
  "authentic-classic": {
    display_name: "Authentic",
    image: "//images.vans.com/is/image/VansBrand/customs-authentic-classic?$scale-original$",
    svg_view: "two-shoes",
    ugc_component_name: "vamp",
    secondary_ugc_component_name: "quarters",
    ugcImageRatio(component = 'vamp') {
      let ratio = 1;
      switch (component) {
        case 'vamp':
          ratio = 815 / 1030; // (height / width) of ugc placement image
          break;
        case 'quarters':
          ratio = 387 / 1033; // (height / width) of ugc placement image
      }
      return ratio;
    },
    product_type: "footwear"
  },
  "slip-on-classic": {
    display_name: "Slip On",
    image: "//images.vans.com/is/image/VansBrand/customs-slipon-classic?$scale-original$",
    svg_view: "two-shoes",
    ugc_component_name: "vamp",
    ugcImageRatio() {
      return 880 / 1028; // (height / width) of ugc placement image
    },
    product_type: "footwear"
  },
  "era-classic": {
    display_name: "Era",
    image: "//images.vans.com/is/image/VansBrand/customs-era-classic?$scale-original$",
    svg_view: "two-shoes",
    ugc_component_name: "vamp",
    ugcImageRatio() {
      return 753 / 1031; // (height / width) of ugc placement image
    },
    product_type: "footwear"
  },
  "old-skool-classic": {
    display_name: "Old Skool",
    image: "https://images.vans.com/is/image/VansBrand/customs-oldskool-classic?$scale-original$",
    svg_view: "two-shoes",
    ugc_component_name: "quarters",
    ugcImageRatio() {
      return 387 / 1033; // (height / width) of ugc placement image
    },
    product_type: "footwear"
  },
  "backpack": {
    display_name: "Backpacks",
    image: "//images.vans.com/is/image/VansBrand/customs-base-img-backpack?$scale-original$",
    svg_view: "front-ugc",
    ugc_component_name: "front",
    ugcImageRatio() {
      return 1020 / 812; // (height / width) of ugc placement image
    },
    image_requirements: {
      minimum_dimensions: [
        800,
        1000
      ],
    },
    product_type: "backpack"
  },
  "unisex-classic-tee-10001": {
    display_name: "Men's Tee",
    image: "URL TBD",
    svg_view: "graphic_front",
    ugc_component_name: "graphic_front",
    ugcImageRatio() {
      return 1020 / 812; // (height / width) of ugc placement image
    },
    svg_size: {
      x: 360,
      y: 200,
      width: 300,
      height: 300
    },
    svg_image_placement: {
      x:0,
      y:0,
      height:1024,
      width:1024
    },
    image_requirements: {
      minimum_dimensions: [
        800,
        1000
      ],
    },
    product_type: "apparel"
  },
  "unisex-classic-tee-10003": {
    display_name: "Men's Tee",
    image: "URL TBD",
    svg_view: "graphic_front",
    ugc_component_name: "graphic_front",
    ugcImageRatio() {
      return 1020 / 812; // (height / width) of ugc placement image
    },
    svg_size: {
      x: 360,
      y: 200,
      width: 300,
      height: 300
    },
    svg_image_placement: {
      x:0,
      y:0,
      height:1024,
      width:1024
    },
    image_requirements: {
      minimum_dimensions: [
        800,
        1000
      ],
    },
    product_type: "apparel"
  },
  "unisex-classic-tee-10005": {
    display_name: "Men's Tee",
    image: "URL TBD",
    svg_view: "graphic_front",
    ugc_component_name: "graphic_front",
    ugcImageRatio() {
      return 1020 / 812; // (height / width) of ugc placement image
    },
    svg_size: {
      x: 360,
      y: 200,
      width: 300,
      height: 300
    },
    svg_image_placement: {
      x:0,
      y:0,
      height:1024,
      width:1024
    },
    image_requirements: {
      minimum_dimensions: [
        800,
        1000
      ],
    },
    product_type: "apparel"
  },
  "unisex-long-sleeve-classic-tee-10006": {
    display_name: "Men's Long Sleeve",
    image: "URL TBD",
    svg_view: "graphic_front",
    ugc_component_name: "graphic_front",
    ugcImageRatio() {
      return 1020 / 812; // (height / width) of ugc placement image
    },
    svg_size: {
      x: 360,
      y: 200,
      width: 300,
      height: 300
    },
    svg_image_placement: {
      x:0,
      y:0,
      height:1024,
      width:1024
    },
    image_requirements: {
      minimum_dimensions: [
        800,
        1000
      ],
    },
    product_type: "apparel"
  },
  "unisex-long-sleeve-classic-tee-10002": {
    display_name: "Men's Long Sleeve",
    image: "URL TBD",
    svg_view: "graphic_front",
    ugc_component_name: "graphic_front",
    ugcImageRatio() {
      return 1020 / 812; // (height / width) of ugc placement image
    },
    svg_size: {
      x: 360,
      y: 200,
      width: 300,
      height: 300
    },
    svg_image_placement: {
      x:0,
      y:0,
      height:1024,
      width:1024
    },
    image_requirements: {
      minimum_dimensions: [
        800,
        1000
      ],
    },
    product_type: "apparel"
  },
  "womens-crew-tee-10007": {
    display_name: "Women's Tee",
    image: "URL TBD",
    svg_view: "graphic_front",
    ugc_component_name: "graphic_front",
    ugcImageRatio() {
      return 1020 / 812; // (height / width) of ugc placement image
    },
    svg_size: {
      x: 360,
      y: 200,
      width: 300,
      height: 300
    },
    svg_image_placement: {
      x:0,
      y:0,
      height:1024,
      width:1024
    },
    image_requirements: {
      minimum_dimensions: [
        800,
        1000
      ],
    },
    product_type: "apparel"
  },
  "womens-long-sleeve-bff-tee-10004": {
    display_name: "Women's Long Sleeve",
    image: "URL TBD",
    svg_view: "graphic_front",
    ugc_component_name: "graphic_front",
    ugcImageRatio() {
      return 1020 / 812; // (height / width) of ugc placement image
    },
    svg_size: {
      x: 360,
      y: 200,
      width: 300,
      height: 300
    },
    svg_image_placement: {
      x:0,
      y:0,
      height:1024,
      width:1024
    },
    image_requirements: {
      minimum_dimensions: [
        800,
        1000
      ],
    },
    product_type: "apparel"
  }
};

const customCheckerboardData = {
  "sk8-hi": {
    display_name: "Sk8-Hi",
    image: "//images.vans.com/is/image/VansBrand/customs-sk8hi-classic?$scale-original$",
    svg_view: "two-shoes",
    ugc_component_name: "quarters",
    product_type: "footwear"
  },
  "authentic-classic": {
    display_name: "Authentic",
    image: "//images.vans.com/is/image/VansBrand/customs-authentic-classic?$scale-original$",
    svg_view: "two-shoes",
    ugc_component_name: "vamp",
    secondary_ugc_component_name: "quarters",
    product_type: "footwear"
  },
  "slip-on-classic": {
    display_name: "Slip On",
    image: "//images.vans.com/is/image/VansBrand/customs-slipon-classic?$scale-original$",
    svg_view: "two-shoes",
    ugc_component_name: "vamp",
    product_type: "footwear"
  },
  "era-classic": {
    display_name: "Era",
    image: "//images.vans.com/is/image/VansBrand/customs-era-classic?$scale-original$",
    svg_view: "two-shoes",
    ugc_component_name: "vamp",
    product_type: "footwear"
  },
  "old-skool-classic": {
    display_name: "Old Skool",
    image: "https://images.vans.com/is/image/VansBrand/customs-oldskool-classic?$scale-original$",
    svg_view: "two-shoes",
    ugc_component_name: "quarters",
    product_type: "footwear"
  },
  "backpack": {
    display_name: "Backpacks",
    image: "//images.vans.com/is/image/VansBrand/customs-base-img-backpack?$scale-original$",
    svg_view: "front-ugc",
    ugc_component_name: "front",
    product_type: "backpack"
  }
};

const randomizerData = {
  "sk8-hi": {
    display_name: "Sk8-hi",
    image: "sk8-hi.jpg",
    svg: "sk8-hi-left-view.svg",
    shadow: "shadow-map-left-view.png",
    punched_eyelts_shadow: "shadow-map-left-view-punched-eyelets.png",
    partnumber: "CSTSK8HiC",
    default_recipe: "000620d0a9208d6cdf29a12c5fd5ec87",
    featured_views: {
      buy_panel: {
        view: "left",
        size: "md"
      },
      mini_cart: {
        view: "left",
        size: "md"
      }
    },
    product_type: "footwear"
  },
  "authentic-classic": {
    display_name: "Authentic",
    image: "authentic-classic.jpg",
    svg: "authentic-classic-left-view.svg",
    shadow: "shadow-map-left-view.png",
    punched_eyelts_shadow: "shadow-map-left-view-punched-eyelets.png",
    partnumber: "CSTAUTHCADT",
    default_recipe: "5d0d3ef661870a5a4e697f6b85a83285",
    featured_views: {
      buy_panel: {
        view: "left",
        size: "md"
      },
      mini_cart: {
        view: "left",
        size: "md"
      }
    },
    product_type: "footwear"
  },
  "slip-on-classic": {
    display_name: "Slip On",
    image: "slip-on-classic.jpg",
    svg: "slip-on-classic-left-view.svg",
    shadow: "shadow-map-left-view.png",
    punched_eyelts_shadow: "shadow-map-left-view-punched-eyelets.png",
    partnumber: "CSTSLPONCADT",
    default_recipe: "bbeee49cf5e274086a179cf86622cee2",
    featured_views: {
      buy_panel: {
        view: "left",
        size: "md"
      },
      mini_cart: {
        view: "left",
        size: "md"
      }
    },
    product_type: "footwear"
  },
  "era-classic": {
    display_name: "Era",
    image: "era-classic.jpg",
    svg: "era-classic-left-view.svg",
    shadow: "shadow-map-left-view.png",
    punched_eyelts_shadow: "shadow-map-left-view-punched-eyelets.png",
    partnumber: "CSTERAC",
    default_recipe: "63fa927383bf11586ca528a202d3efee",
    featured_views: {
      buy_panel: {
        view: "left",
        size: "md"
      },
      mini_cart: {
        view: "left",
        size: "md"
      }
    },
    product_type: "footwear"
  },
  "old-skool-classic": {
    display_name: "Old Skool",
    image: "old-skool-classic.jpg",
    svg: "old-skool-classic-left-view.svg",
    shadow: "shadow-map-left-view.png",
    punched_eyelts_shadow: "shadow-map-left-view-punched-eyelets.png",
    partnumber: "CSTOLDSKLC",
    default_recipe: "eff610acffc76fdeeda6c759d57135a4",
    featured_views: {
      buy_panel: {
        view: "left",
        size: "md"
      },
      mini_cart: {
        view: "left",
        size: "md"
      }
    },
    product_type: "footwear"
  },
  "backpack": {
    display_name: "Backpack",
    image: "backpack.jpg",
    svg: "backpack.svg",
    shadow: "shadow-map-front-view.png",
    punched_eyelts_shadow: "shadow-map-left-view-punched-eyelets.png",
    partnumber: "CSTBKP",
    default_recipe: "e7837e8d14459251e8e695317d8c531f",
    featured_views: {
      buy_panel: {
        view: "front",
        size: "md"
      },
      mini_cart: {
        size: "md-square-white",
        view: "front_white"
      }
    },
    product_type: "backpack"
  }
};



export {
  customCheckerboardData,
  patternMakerData,
  randomizerData,
  ugcEntryPointData
}